var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefreshblueicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0825 1.90937C9.90437 0.73125 8.2875 0 6.49187 0C2.90062 0 0 2.90875 0 6.5C0 10.0913 2.90062 13 6.49187 13C9.5225 13 12.0494 10.9281 12.7725 8.125H11.0825C10.4162 10.0181 8.6125 11.375 6.49187 11.375C3.8025 11.375 1.61687 9.18937 1.61687 6.5C1.61687 3.81063 3.8025 1.625 6.49187 1.625C7.84062 1.625 9.04312 2.18563 9.92062 3.07125L7.30437 5.6875H12.9919V0L11.0825 1.90937Z",
    fill: "#003C88"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshblueicon);
export default __webpack_public_path__ + "static/media/refreshblueicon.e2babbc114a86063f2ae23548dda0370.svg";
export { ForwardRef as ReactComponent };